(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.publication_ajax_popup = {
    attach: function (context, settings) {
      $(once("form", ".js-pub-popup", context))
        .each(function (i, form) {
          bindFormEvents($(form).find(".pub-popup__content"));
        });

      function bindFormEvents(form) {
        const $publicationBtn = form.find(".js-publication-submit-popup-btn");
        const pubPopup = document.querySelector('.pub-popup__block');
        if (pubPopup) {
          pushData({
            event: 'ga-event',
            eventCategory: 'pop-up',
            eventAction: 'view',
            eventLabel: 'publication-popup_view',
          });
        }
        $publicationBtn.on("click", function (e) {
          const $publicationForm = $(this).closest("form");
          const $styledBtn = $(this).closest(".form__cta");
          const $formText = form.parent().find(".form-text");
          const $hiddenSuccess = form.parent().find(".success-message");
          const $hiddenError = form.parent().find(".error-message");
          const $publRequired = $publicationForm.find(".required-field");
          const $requiredCheckboxes =
          $publicationForm.find(".required-checkbox");
          let $valid = [];

          const contactTrackId = $(".js-publication-gatrackid", context);
          const contactClientId = $(".js-publication-ga_client_id", context);
          const contactUserGa = $(".js-publication-gausercat", context);

          if (typeof ga !== 'undefined') {
            ga(() => {
              const gaCont = ga.getAll()[0];
              const clientId = gaCont.get("clientId") || "undefined";
              const trackId = gaCont.get("trackingId") || "undefined";
              const userId = gaCont.get("userGa") || "undefined";

              if (contactTrackId.length) {
                contactTrackId.each(function (index, input) {
                  input.value = trackId;
                });
              }

              if (contactClientId.length) {
                contactClientId.each(function (index, input) {
                  input.value = clientId;
                });
              }

              if (contactUserGa.length) {
                contactUserGa.each(function (index, input) {
                  input.value = userId;
                });
              }
            });
          };

          const utmSourcePb = $(".js-publication-utm-source", context);
          const utmMediumPb = $(".js-publication-utm-medium", context);
          const utmCampaignPb = $(".js-publication-utm-campaign", context);
          const utmContentPb = $(".js-publication-utm-content", context);
          const utmTermPb = $(".js-publication-utm-term", context);


          const sourceVal = window.parent.sessionStorage.getItem('utm_source') || "undefined";
          const mediumVal = window.parent.sessionStorage.getItem('utm_medium') || "undefined";
          const campaignVal = window.parent.sessionStorage.getItem('utm_campaign') || "undefined";
          const contentVal = window.parent.sessionStorage.getItem('utm_content') || "undefined";
          const termVal = window.parent.sessionStorage.getItem('utm_term') || "undefined";

          if (utmSourcePb.length) {
            utmSourcePb.each(function (index, input) {
              input.value = sourceVal;
            });
          }
          if (utmMediumPb.length) {
            utmMediumPb.each(function (index, input) {
              input.value = mediumVal;
            });
          }
          if (utmCampaignPb.length) {
            utmCampaignPb.each(function (index, input) {
              input.value = campaignVal;
            });
          }
          if (utmContentPb.length) {
            utmContentPb.each(function (index, input) {
              input.value = contentVal;
            });
          }
          if (utmTermPb.length) {
            utmTermPb.each(function (index, input) {
              input.value = termVal;
            });
          }

          const pageTitleData = $("body", context).data("pagetitle");
          const pageTitleValue = $(".page-title", context);

          if (pageTitleValue.length) {
            pageTitleValue.each(function (index, input) {
              input.value = pageTitleData;
            });
          }

          function pushData(data) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ...data });
          }

          function pushPublitasData() {
            pushData({
              event: "ga-event",
              eventCategory: "PDF Library Subs",
              eventAction: `View`,
              eventLabel: `${pageTitleData}`,
            });
          }

          $requiredCheckboxes.each((index, checkbox) => {
            const $parent = $(checkbox).closest(".js-form-row");
            const $errorField = $parent.find(".js-field-error");
            if (!checkbox.checked) {
              if ($errorField) {
                $errorField.text($errorField.data("empty"));
                $valid.push(false);
              }
              checkbox.classList.add("is-empty");
            } else {
              checkbox.classList.remove("is-empty");
              $errorField.text("");
            }
          });

          function validateReqFields($publRequired) {
            $publRequired.each(function (i, input) {
              const $parent = $(input).closest(".js-form-row");
              const $errorField = $parent.find(".js-field-error");

              if (input.value == "") {
                input.classList.add("is-empty");
                input.classList.remove("not-empty");
                if ($errorField) {
                  $errorField.text($errorField.data("empty"));
                  $valid.push(false);
                }
              } else {
                input.classList.add("not-empty");
                input.classList.remove("is-empty");
                if ($errorField) {
                  $errorField.text("");
                }
                if (input.getAttribute("type") === "email") {
                  if (!validateEmail(input)) {
                    input.classList.remove("not-empty");
                    input.classList.add("is-empty");
                    if ($errorField) {
                      $errorField.text($errorField.data("invalid"));
                      $valid.push(false);
                    }
                  }
                  const flag = $parent.data('emailBlocking');
                  if (flag === 1) {
                    const emailDomainsArray = $parent.data('emailDomains').length ? $parent.data('emailDomains').split('|') : '';
                    const emailDomainError = $errorField.data('blocked').length ? $errorField.data('blocked') : '';
                    const mailProvider = input.value.split('@').pop().split('.')[0];
                    if (emailDomainsArray.includes(mailProvider)) {
                      input.classList.add("is-empty");
                      input.classList.remove("not-empty");
                      $errorField.text(emailDomainError);
                    }
                  }
                }
              }
            });
          }
          validateReqFields($publRequired);
          $publRequired.blur((e) => {
            validateReqFields($(e.target));
          });

          function validateEmail(field) {
            const re = /[a-zA-Z0-9+-_%.]+@[a-zA-Z0-9_-]+\.[A-Za-z0-9]{2,64}/;
            return re.test(field.value);
          }
          if ($valid.includes(false)) {
            e.preventDefault();
            $valid = [];
          } else {
            pushData({
              event: 'ga-event',
              eventCategory: 'pop-up',
              eventAction: 'click',
              eventLabel: 'publication-popup',
            });

            e.preventDefault();
            const _continue = function(e, form) {
              $.ajax({
                url: "/submit-custom-publication-form",
                type: "POST",
                data: $publicationForm.serialize(),
                dataType: "json",
                beforeSend: function () {
                  $("#js-publication-loader").removeClass("hidden");
                  $publicationBtn.prop("disabled", true);
                },
                success: function (response) {
                  if (typeof response.page_status !== "undefined" && response.page_status == "success") {
                    $publicationBtn.prop("disabled", true);
                    $("#js-publication-loader").addClass("hidden");
                    $styledBtn.addClass("form__cta--success");
                    $formText.css("display", "none");
                    $hiddenSuccess.css("display", "block");

                    var exp_date = new Date();
                    exp_date.setTime(exp_date.getTime() + (183 * 24 * 60 * 60 * 1000));
                    document.cookie = 'hide_publication_popup_' + langCode + '=1; expires=' + exp_date + '; path=/';
                    setTimeout(() => {
                      $(".pub-popup").removeClass("show-popup");
                      enableScroll()
                      pushPublitasData();
                    }, 1000);
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  } else {
                    e.preventDefault();
                    $styledBtn.addClass("form__cta--fail");
                    $publicationBtn.prop("disabled", true);
                    if ($hiddenError.text().length > 0) {
                      $formText.css("display", "none");
                      $hiddenError.css("display", "block");
                    } else {
                      $formText.css("display", "block");
                    }
                  }
                },
                error: function () {
                  $publicationForm[0].reset();
                },
              });
            }

            if (document.getElementById('h-captcha-sitekey-popup').value) {
              const key = document.getElementById('h-captcha-sitekey-popup').value;
              console.log('Setting up hCaptcha for form index: pubpopup');
              const g = document.createElement('div');
              g.className = 'captcha_widget-id';
              form.append(g);
              console.log('hCaptcha container added to the form. pubpopup');
              const _widgetID = hcaptcha.render(g, {
                size: 'invisible',
                sitekey: key,
                callback: function(response) {
                  hcaptchaSetHCFieldWebform(response, form);
                }.bind(form)
              });
              console.log('widget2:', _widgetID);
              console.log('Form submit intercepted for form index: pubpopup');
              hcaptcha.execute(_widgetID); // Execute the hCaptcha
              console.log('hCaptcha execute called for widget ID:', _widgetID);
              const hcaptchaSetHCFieldWebform = function(response, form) {
                console.log('hCaptcha token received: pubpopup', response);
                window.havePasscode = true;
                window.curPasscode = response;
                const response_placeholder = document.getElementById('h-captcha-response-pub-popup');
                if (response_placeholder) response_placeholder.value = response;
                console.log('hCaptcha token set in form: pubpopup');
                _continue(e, form);
              };
            } else {
              _continue(e, form);
            }

            return false;
          }
        });
        const $hoverFields = form.find(".js-form-input, .js-select2, .js-form-textarea");
        $hoverFields.blur((e) => {
          handleFocus(e, $(e.target));
        });
        $hoverFields.focus((e) => {
          handleFocus(e, $(e.target));
        });
        function handleFocus(e, field) {
          const parent = field.closest(".js-form-row");
          if (typeof e.type !== "undefined" && e.type === "focus") {
            parent.addClass("has-focus");
            return;
          }
          if (field.val().trim() === "") {
            parent.removeClass("has-focus");
          } else {
            parent.addClass("has-focus");
          }
        }
        const body = document.querySelector('body');
        const langCode = body.getAttribute('data-page-language');
        const cookieRolePulic = getCookie(`hide_publication_popup_${langCode}`);

        function getCookie (name) {
          const value = `; ${document.cookie}`;
          const parts = value.split(`; ${name}=`);
          if (parts.length === 2) return parts.pop().split(';').shift();
        };
        if (cookieRolePulic === '1') {
          $(".pub-popup").removeClass("show-popup");
          enableScroll()
        } else {
          $(".js-pub-popup").addClass("show-popup");
          disableScroll()
          }

      }
    },
  };

})(jQuery, Drupal, once);
